import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Heart } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

const Impressum = () => {
  const navigate = useNavigate();

  const handleDonateClick = () => {
    navigate('/#donate');
    setTimeout(() => {
      const element = document.getElementById('donate');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };
  return (
    <div className="min-h-screen bg-warm-beige pt-32 pb-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Back Button */}
          <motion.div
            className="mb-8"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Link
              to="/"
              className="inline-flex items-center space-x-2 text-olive-green hover:text-olive-dark transition-colors font-medium"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>Zurück zur Startseite</span>
            </Link>
          </motion.div>

          {/* Impressum Content */}
          <motion.div
            className="bg-white rounded-2xl shadow-xl p-12 border border-olive-green/10"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl font-bold text-charcoal mb-8 font-heading">
              Impressum
            </h1>

            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-bold text-charcoal mb-4 font-heading">
                Angaben gemäß § 5 TMG.
              </h2>

              <div className="mb-8">
                <p className="text-charcoal/80 leading-relaxed mb-2">
                  <strong>hay - humanity. action. you. e.V.</strong><br />
                  Verein für humanitäre Hilfe und Solidarität<br />
                  Königsallee 24<br />
                  44789 Bochum<br />
                  Deutschland
                </p>
              </div>

              <div className="mb-8">
                <h3 className="text-xl font-bold text-charcoal mb-3 font-heading">
                  Vertreten durch den Vorstand:
                </h3>
                <p className="text-charcoal/80 leading-relaxed">
                  Stefan Hay, Thomas Hay
                </p>
              </div>

              <div className="mb-8">
                <h3 className="text-xl font-bold text-charcoal mb-3 font-heading">
                  Kontakt:
                </h3>
                <p className="text-charcoal/80 leading-relaxed">
                  <strong>E-Mail:</strong> <a href="mailto:info@hayforhumanity.de" className="text-olive-green hover:text-olive-dark transition-colors">info@hayforhumanity.de</a><br />
                  <strong>Telefon:</strong> <a href="tel:+4915679713491" className="text-olive-green hover:text-olive-dark transition-colors">+49 15679 713491</a>
                </p>
              </div>

              <div className="mb-8">
                <h3 className="text-xl font-bold text-charcoal mb-3 font-heading">
                  Eintragung im Vereinsregister:
                </h3>
                <p className="text-charcoal/80 leading-relaxed">
                  Eingetragener Verein (e.V.)<br />
                  <strong>Registernummer:</strong> VR 5495<br />
                  <strong>Registergericht:</strong> Amtsgericht Bochum
                </p>
              </div>

              <div className="mb-8">
                <h3 className="text-xl font-bold text-charcoal mb-3 font-heading">
                  Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:
                </h3>
                <p className="text-charcoal/80 leading-relaxed">
                  Stefan Hay<br />
                  Königsallee 24, 44789 Bochum
                </p>
              </div>

              {/* Disclaimer */}
              <div className="mt-12 p-6 bg-olive-green/10 rounded-xl border-l-4 border-olive-green">
                <h3 className="text-xl font-bold text-charcoal mb-3 font-heading">
                  Haftungsausschluss:
                </h3>
                <p className="text-charcoal/80 text-sm leading-relaxed">
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
                  Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. 
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                  nach den allgemeinen Gesetzen verantwortlich.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Donate CTA */}
          <motion.div
            className="mt-8 bg-gradient-to-r from-olive-green to-olive-dark rounded-2xl p-8 text-white text-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <Heart className="w-12 h-12 mx-auto mb-4" />
            <h3 className="text-2xl font-bold mb-4 font-heading">
              Unterstütze unsere Mission.
            </h3>
            <p className="text-lg text-white/90 mb-6 leading-relaxed max-w-2xl mx-auto">
              Jede Spende hilft uns, Menschen in Not zu unterstützen.
            </p>
            <button
              onClick={handleDonateClick}
              className="bg-white text-olive-green hover:bg-cream px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-xl"
            >
              Jetzt spenden
            </button>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;